import moment from 'jalali-moment';
import classNames from 'classnames';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Routes } from '@/routes';
import { Flex } from '@/components';
import { useThemeToken } from '@/hooks';
import { useTranslation } from 'react-i18next';

export interface SurveysListProps {
  surveys: SurveyEntity[];
  showIgnore?: boolean;
  onIgnore?: (id: number) => void;
  extraSpace?: boolean;
}

const SurveyType = {
  SURVEY: { label: 'survey', value: 1 },
  ELECTION: { label: 'election', value: 2 },
  EXAM: { label: 'exam', value: 3 }
};

export default function SurveysList({
  surveys,
  onIgnore = () => { },
  showIgnore = true,
  extraSpace = false
}: SurveysListProps) {

  const navigate = useNavigate();
  const [t] = useTranslation(['common', 'survey']);
  const { colorPrimaryDarker } = useThemeToken();
  const navigateToSurvey = (id: number) => navigate(Routes.SurveyParticipate.replace(':surveyId', String(id)));

  const className = classNames(
    'bg-gray-100 p-2 rounded-md overflow-hidden',
    { 'p-4': extraSpace }
  );

  return (
    <Flex gap={extraSpace ? 16 : undefined} direction="column">
      {surveys.map(item => (
        <Flex
          key={item.id}
          direction="column"
          className={className}
        >
          <Flex align="center">
            <span className="font-medium" style={{ color: colorPrimaryDarker }}>
              {t(`survey:labels.${SurveyType[item.type].label}`)}
            </span>
          </Flex>
          <span>{item.name}</span>
          <div className="text-app-gray-darker flex gap-1">
            <Flex gap={2} direction="column">
              <Flex>
                <span className="w-[80px]">{t('common:labels.start-date')}:</span>
                <span>{moment.from(item.fromDate, 'en').format('jDD jMMMM HH:mm')}</span>
              </Flex>
              <Flex>
                <span className="w-[80px]">{t('common:labels.end-date')}:</span>
                <span>{moment.from(item.toDate, 'en').format('jDD jMMMM HH:mm')}</span>
              </Flex>
            </Flex>
          </div>
          <Flex justify="flex-end">
            <Button
              type="primary"
              size="middle"
              className="!text-sm gap-0.5"
              onClick={() => navigateToSurvey(item.id)}>
              <span>{t('survey:labels.participate-in')}</span>
              <span>{t(`survey:labels.${SurveyType[item.type].label}`)}</span>
            </Button>
            {showIgnore &&
              <Button
                size="middle"
                type="dashed"
                onClick={() => onIgnore(item.id)}
                disabled={item.mandatory}
                className="!text-sm min-w-[80px]"
              >
                {t('common:labels.not-yet')}
              </Button>
            }
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
}
